'use strict';
angular
    .module('editingCenterSignedModule', [
        'editingCenterSignedRouterModule',
        'editingCenterSignedRetractionModule',
        'editingCenterSignedFocusModule',
    ])
    .controller('editCompileSignedCtroller', [
        '$stateParams',
        '$q',
        '$filter',
        'trsHttpService',
        '$scope',
        '$window',
        '$state',
        'modalDialog',
        'trsspliceString',
        '$timeout',
        'initSingleSelecet',
        'editingCenterService',
        'storageListenerService',
        'globleParamsSet',
        'editingCenterAppService',
        'editcenterRightsService',
        'editIsLock',
        'localStorageService',
        'messagePublishService',
        'editRepetitiveBtnService',
        'newMediaService',
        'appConst',
        function (
            $stateParams,
            $q,
            $filter,
            trsHttpService,
            $scope,
            $window,
            $state,
            modalDialog,
            trsspliceString,
            $timeout,
            initSingleSelecet,
            editingCenterService,
            storageListenerService,
            globleParamsSet,
            editingCenterAppService,
            editcenterRightsService,
            editIsLock,
            localStorageService,
            messagePublishService,
            editRepetitiveBtnService,
            newMediaService,
            appConst
        ) {
            initStatus();
            // initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.getPageSize(),
                };
                $scope.data = {
                    ORIGINCHANNEL: [],
                    printResult: [],
                    items: [],
                    trench: appConst.params.listenStroageKey,
                    firstPageItems: [], // 第一页请求的数据
                    selectedArray: [],
                    copyCurrPage: 1,
                    editPath: editingCenterAppService.initEditPath(),
                    // 一个栏目发送一次请求，预防多次发请求
                    requestedColumnsBtnRight: {}
                };
                $scope.childStatus = {
                    // 图片数组的string
                    checkString: 'DOC_PICTURELIST',
                    // 图片数组中表示url地址的string
                    picString: 'SRCPICURL',
                    originPicUrl: 'SRCPICURL'
                };
                $scope.status = {
                    showFixPosition: true,
                    batchOperateBtn: {
                        hoverStatus: '',
                        clickStatus: '',
                    },
                    hasphoto: false, // 是否是图集稿
                    hasphotoflag: true, // 判断是否人为点击图集切换模式
                    detailMethodname: {
                        1: 'getNewsDoc',
                        2: 'getPicsDoc',
                        3: 'getSpecialDoc',
                        4: 'getLinkDoc',
                        5: 'getActivityDoc',
                        6: 'getTopicDoc',
                        7: 'getVideoDoc',
                        8: 'getLiveDoc',
                        12: 'getAudioDoc',
                    },
                    draftType: {
                        news: '1',
                        atlas: '2',
                        subject: '3',
                        linkDoc: '4',
                    },
                    onlyMine: false,
                    isESSearch: false,
                    channelId: $stateParams.channelid,
                    hasChildren: $stateParams.hasChildren,
                    siteId: $stateParams.siteid,
                    hasHide: false, // 包含隐藏的稿件
                    hasNoHide: true, // 包含未隐藏的稿件
                    hasFixed: false, // 包含固定位置的稿件
                    hasNoFixed: true, // 包含未定位的稿件
                    isShowMorebtnLength: 5, // 大于5个按钮则更多显示
                    isAllColumns: $state.params.channelid === '0', // 表示全部栏目
                };
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'querySignedDoc',
                    PageSize: $scope.page.PAGESIZE,
                    CurrPage: $scope.page.CURRPAGE,
                    ChannelId: $stateParams.channelid,
                    SiteId: $stateParams.siteid,
                };
                $scope.fixPos = []; // 被固定位置的稿件集合
                // 监听未保存的专题分组，并删除
                $window.addEventListener('storage', function (e) {
                    var draftInfo = localStorageService.get('unsavedGroup');
                    if (draftInfo && draftInfo.specialGroupIds) {
                        localStorageService.remove('unsavedGroup');
                        deleteUnsavedGroup(draftInfo).then(function (data) {
                            // console.log('删除分组成功！');
                        });
                    }
                });
            }

            /**
             * [deleteUnsavedGroup description] 删除未保存的专题分组
             * @param  {[type]} draftInfo [description] 分组信息和稿件信息
             * @return {[type]}           [description]
             */
            function deleteUnsavedGroup(draftInfo) {
                var defer = $q.defer();
                var params;
                if (draftInfo.metadataid == '0') {
                    params = {
                        serviceid: 'mlf_specialgroup',
                        methodname: 'deleteUnrelatedSpecialGroups',
                        ObjectIds: draftInfo.specialGroupIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve();
                    });
                } else {
                    params = {
                        serviceid: 'mlf_specialgroup',
                        methodname: 'deleteSpecialGroupFromData',
                        MetaDataId: draftInfo.metadataid,
                        SpecialGroupIds: draftInfo.specialGroupIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve();
                    });
                }
                return defer.promise;
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                if (!$stateParams.channelid) {
                    $scope.status.hidePage = true; // 如果栏目参数不足，隐藏改页面
                    return;
                }
                if ($scope.status.isAllColumns) {
                    delete $scope.params.ChannelId;
                    // 增加一个参数 标识全部栏目的参数
                    $scope.params.IsLoadAllChnl = true;
                    $scope.status.btnRights = editingCenterAppService.initQianFaBtnRight();
                    initDropDown();
                    requestData();
                } else {
                    queryChannelDetail().then(function () {
                        initDropDown();
                        requestData();
                    });
                    cancelFixedPosition();
                    editcenterRightsService.initAppListBtn('app.yiqianfa', $stateParams.channelid).then(function (rights) {
                        $scope.status.btnRights = rights;
                        getObjLength($scope.status.btnRights);
                    });
                }
                listenStorage();
            }

            // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
            $scope.requestData = function() {
                initData();
            };

            /**
             * [getObjLength description]计算对象长度
             *
             * @param   {[type]}  obj  [obj description]
             *
             * @return  {[type]}       [return description]
             */
            function getObjLength(obj) {
                var size = 0,
                    key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        size++;
                    }
                }
                $scope.status.btnLength = size;
            }

            /**
             * [requestData description] 请求数据
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function getData() {
                var deferred = $q.defer();
                var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $timeout(function () {
                        var ListItems = data.DATA;
                        // dealMulSign(data.DATA);
                        $scope.data.items = ListItems;
                        if ($scope.page.CURRPAGE === 1) {
                            $scope.data.firstPageItemsLenth = ListItems.length;
                        }
                        if ($scope.data.selectedDocType) {
                            if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value == '2' && $scope.status.hasphotoflag === true) {
                                $scope.status.hasphoto = true;
                            } else {
                                $scope.status.hasphoto = false;
                            }
                        }
                        !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                        $scope.data.selectedArray = [];
                        // requestListImg(ListItems).then(function (data) {
                        //     var secondParams = {
                        //         datas: ListItems,
                        //         requestDatas: data,
                        //         newAttr: 'ALLIMG', //需要新增的属性名称
                        //     }
                        //     editingCenterService.dealSecondRequest(secondParams);
                        // });
                        deferred.resolve(data);
                    });
                });
                return deferred.promise;
            }

            /**
             * [requestData description] 请求数据更新状态
             * @return {[type]} [description]
             */
            function requestData() {
                getData().then(function () {
                    initFixed();
                    // 处理多签标记
                    editRepetitiveBtnService.multiSignedMark($scope.data.items);
                    // 处理图示
                    editRepetitiveBtnService.dealListImg($scope.data.items);
                });
            }

            /**
             * [description] 监听勾选的数据
             * @param  {[type]} newValue) {                       var hasFixed [description]
             * @return {[type]}           [description]
             */
            $scope.$watch('data.selectedArray.length', function (newValue) {
                var hasFixed = false;
                var hasNoFixed = false;
                var hasHide = false;
                var hasNoHide = false;
                angular.forEach($scope.data.selectedArray, function (item) {
                    angular.isDefined(item.GDORDER) ? (hasFixed = true) : (hasNoFixed = true);
                    item.HIDDEN == '1' ? (hasHide = true) : (hasNoHide = true);
                    $scope.status.hasFixed = hasFixed;
                    $scope.status.hasNoFixed = hasNoFixed;
                    $scope.status.hasHide = hasHide;
                    $scope.status.hasNoHide = hasNoHide;
                });
            });

            /**
             * [requestListImg description]查询列表图示
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            // function requestListImg(items) {
            //     var defer = $q.defer();
            //     if (!items || items.length < 1) {
            //         defer.resolve([]);
            //     } else {
            //         var params = {
            //             serviceid: 'mlf_myrelease',
            //             methodname: 'queryAllImgLogo',
            //             metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            //             defer.resolve(data);
            //         });
            //     }
            //     return defer.promise;
            // }

            /**
             * [initFixed description] 初始化固定位置的稿件
             * @return {[type]} [description]
             */
            function initFixed() {
                angular.forEach($scope.data.items, function (data, index) {
                    if (data.GDORDER && $scope.fixPos.indexOf(Number(data.GDORDER)) < 0) {
                        $scope.fixPos.push(Number(data.GDORDER));
                    }
                });
            }

            /**
             * [initDropDown description]初始化下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                // $scope.data.singleJsons = initSingleSelecet.docStatus();
                // $scope.data.docStatus = angular.copy($scope.data.singleJsons[0]);
                // 根据可新建稿件类型初始化‘全部稿件’下拉框
                // editingCenterService.dealStorage($scope);
                var docTypeJsons = initSingleSelecet.appDocType();
                if (!$scope.status.isAllColumns) {
                    $scope.data.docTypeJsons = [];
                    $scope.data.docTypeJsons.push(docTypeJsons[0]);
                    for (var i = 0; i < docTypeJsons.length; i++) {
                        for (var j in $scope.data.manuscriptTypes) {
                            if (docTypeJsons[i].value == $scope.data.manuscriptTypes[j]) {
                                $scope.data.docTypeJsons.push(docTypeJsons[i]);
                                break;
                            }
                        }
                    }
                    if ($scope.data.manuscriptTypes.indexOf($scope.params.DocType) === -1) {
                        delete $scope.params.DocType;
                        $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
                    }
                } else {
                    $scope.data.docTypeJsons = docTypeJsons;
                }
                $scope.data.timeTypeJsons = initSingleSelecet.timeType();
                $scope.data.selectedTimeType = angular.copy($scope.data.timeTypeJsons[0]);
                $scope.data.sortTypeJsons = initSingleSelecet.sortType();
                $scope.data.sortType = angular.copy($scope.data.sortTypeJsons[1]);
                $scope.data.classifyJsons = initSingleSelecet.iWoEntire();
                $scope.data.selectedClassify = angular.copy($scope.data.classifyJsons[0]);
            }

            /**
             * [queryChannelDetail description] 根据栏目ID获取可新建稿件类型
             * @return {[type]} [description]
             */
            function queryChannelDetail() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'queryChannelDetail',
                    ChannelId: $stateParams.channelid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.manuscriptTypes = data[0].APPOPERTYPE.split(',');
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description] 参数对象
             */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForAppSignedDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [
                            {
                                searchField: $scope.data.selectedClassify.value,
                                keywords: $scope.keywords ? $scope.keywords : '',
                            },
                            {
                                searchField: 'docType',
                                keywords: $scope.data.selectedDocType ? $scope.data.selectedDocType.value : '',
                            },
                            {
                                searchField: 'timeType',
                                keywords:
                                    angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                        ? $scope.data.fromdate + ',' + $scope.data.untildate
                                        : $scope.data.selectedTimeType.value,
                            },
                            {
                                searchField: 'isOnlyMine',
                                keywords: $scope.status.onlyMine,
                            },
                            {
                                searchField: 'channelid',
                                keywords: $stateParams.channelid,
                            },
                            {
                                searchField: '_sort',
                                keywords: $scope.data.sortType.value,
                            },
                        ],
                    },
                };
                // 所有栏目下  不传channelid 传siteid
                if ($scope.status.isAllColumns){
                    esParams.searchParams.searchFields[4] = {
                        searchField: 'siteid',
                        keywords: $state.params.siteid,
                    };
                    $scope.status.btnRights = editingCenterAppService.initQianFaBtnRight();
                }
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenApp(function () {
                    $scope.status.isESSearch = false;
                    requestData();
                    storageListenerService.removeListener('app');
                }, $scope);
            }

            // /**
            //  * [pushBar description] 稿件推头条
            //  * @return {[type]} [description]
            //  */
            // $scope.pushBar = function() {
            //     var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, "CHNLDOCID", ",");
            //     var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, "METADATAID", ",");
            //     pushBar(chnlDocIds, metaDataId);

            // };

            // /**
            //  * [pushBar description] 推头条函数
            //  * @param  {[type]} chnlDocIds  [description]
            //  * @param  {[type]} MetaDataIds [description]
            //  * @return {[type]}             [description]
            //  */
            // function pushBar(chnlDocIds, metaDataId) {
            //     modalDialog.confirmModal("推头条", "您确定推送头条么？", function() {
            //         var params = {
            //             "serviceid": "mlf_appoper",
            //             "methodname": "pushTopChnl",
            //             "ChnlDocIds": chnlDocIds,
            //             "MetaDataIds": metaDataId,
            //             "ChannelId": $stateParams.channelid,
            //         };
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            //             modalDialog.alertType("推头条成功", "", "success", false, function() {
            //                 requestData();
            //             });
            //         });
            //     });
            // }

            /**
             * [checkSecondReview description] 判断所选稿件中是否带有二次审核的稿件
             * @return {[type]} [description]
             */
            function checkSecondReview() {
                var secondReview = false;
                angular.forEach($scope.data.selectedArray, function (data, index) {
                    if (angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1') {
                        secondReview = true;
                    }
                });
                return secondReview;
            }

            /**
             * [retraction description] 稿件取消签发
             * @return {[type]} [description]
             */
            $scope.retraction = function () {
                var isSecondReview = checkSecondReview();
                if (isSecondReview === true) {
                    modalDialog.alertType('无法进行操作', '所选稿件中包含二次审核的稿件', 'info', 'confirm', function () { });
                    return;
                }
                $scope.status.isESSearch = false;
                var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                $scope.loadingPromise = editingCenterService.beforeRetractOper($scope.data.selectedArray).then(function (data) {
                    if (data === 'noneed') {
                        retraction(chnlDocIds, metaDataId);
                    } else {
                        editingCenterService.beforeRetractionModel(
                            {
                                data: data,
                                selectedArray: $scope.data.selectedArray,
                            }, function () {
                                retraction(chnlDocIds, metaDataId, 1);
                            });
                    }

                });
            };

            /**
             * [retraction description]取消签发函数
             * @return  {[type]}              [return description]
             */
            function retraction() {
                newMediaService.retraction($scope, appConst.params.retraction);
            }

            /**
             * [move description] 移动稿件
             * @return {[type]} [description]
             */
            $scope.move = function () {
                $scope.status.isESSearch = false;
                editingCenterAppService.moveDraft('移动稿件', $stateParams.siteid, $stateParams.channelid, 6, function (data) {
                    var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                    var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'moveYiQianFaMetaDatas',
                        SrcChannelId: $stateParams.channelid,
                        ChnlDocIds: chnlDocIds,
                        MetaDataIds: metaDataId,
                        ToChannelId: data.channelid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('稿件移动成功', '', 'success', false, function () {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [goToDetail description] 图集模式跳转
             * @return  {[type]}  [return description]
             */
            $scope.goToDetail = function(item){
                $scope.appPreview(item);
                var params = {
                    appchannelid: $scope.status.channelId,
                    appchnldocid: item.CHNLDOCID,
                    appsiteid: $scope.status.siteId,
                    appmetadataid: item.METADATAID,
                    appplatform: 2,
                    appdoctype: item.DOCTYPEID
                };
                var url = $state.href('appPreview', params);
                window.open(url);
            };

            /**
             * [supply description] 稿件供稿
             *
             * @return  {[type]}  [return description]
             */
            $scope.supply = function () {
                editingCenterService.feedPopup({
                    manuscripts: $scope.data.selectedArray,
                    mediaType: '1',
                    channelId: $stateParams.channelid
                }).then(function (data) {
                    modalDialog.multiReportsAlert(data, function () {
                        requestData();
                    });
                });
            };

            /**
             * [outSending description] 稿件外发
             * @return {[type]} [description]
             */
            $scope.outSending = function () {
                $scope.status.isESSearch = false;
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
                if (temp.length < 1) {
                    editingCenterService.outSending('', function (result) {
                        outSendingDraft(result.selectItems);
                    });
                } else {
                    modalDialog.alertType('只能外发新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [outSendingDraft description]外发函数
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            function outSendingDraft(items) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'appYiQianFaSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                            requestData();
                        });
                    },
                    function () {
                        $scope.data.selectedArray = [];
                    }
                );
            }

            /**
             * [examDraftType description]检验稿件类型
             * @param  {[obj]} elm [description]稿件的具体信息
             * @return {[type]}     [description]
             */
            $scope.examDraftType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2;
                }
            };

            /**
             * [collect description] 稿件收藏
             * @return {[type]} [description]
             */
            $scope.collect = function () {
                $scope.status.isESSearch = false;
                if (editcenterRightsService.judgeCanBeCollected($scope.data.selectedArray)) {
                    modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                    return;
                } else {
                    var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                    var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                    modalDialog.alertType('', '确认收藏稿件', 'ask', true, function () {
                        var params = {
                            serviceid: 'mlf_appoper',
                            methodname: 'collectionMetaDatas',
                            ChnlDocIds: chnlDocIds,
                            MetaDataIds: metaDataId,
                            ChannelId: $stateParams.channelid,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                            modalDialog.alertType('收藏成功', '', 'success', false);
                            requestData();
                        });
                    });
                }

                // var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
                // if (temp.length < 1) {
                //     var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                //     var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                //     modalDialog.alertType('', '确认收藏稿件', 'ask', true, function () {
                //         var params = {
                //             serviceid: 'mlf_appoper',
                //             methodname: 'collectionMetaDatas',
                //             ChnlDocIds: chnlDocIds,
                //             MetaDataIds: metaDataId,
                //             ChannelId: $stateParams.channelid,
                //         };
                //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                //             modalDialog.alertType('收藏成功', '', 'success', false);
                //             requestData();
                //         });
                //     });
                // } else {
                //     modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', false);
                // }
            };

            /**
             * [printBtn description] 稿件打印
             * @return {[type]} [description]
             */
            $scope.printBtn = function () {
                $scope.status.isESSearch = false;
                editingCenterAppService.printDoc($scope);
            };

            /**
             * [stick description]置顶
             * @return {[type]} [description] null
             */
            $scope.stick = function () {
                $scope.status.isESSearch = false;
                if ($scope.data.selectedArray[0].FOCUSSHELVESSTATUS == '1' || $scope.data.selectedArray[0].FOCUSSHELVESSTATUS == '2') {
                    modalDialog.alertType('该稿件已上架为焦点图，无法置顶', '', 'warning', false);
                    return;
                }
                if ($scope.data.selectedArray[0].GDORDER > 0) {
                    modalDialog.alertType('该文档已固定位置,无法进行置顶操作', '', 'warning', false);
                    return;
                }
                if ($scope.data.selectedArray.length !== 1) {
                    modalDialog.alertType('请选择单篇稿件', '', 'warning', false);
                    return;
                }
                if ($scope.data.selectedArray[0].GDORDER > 0) {
                    modalDialog.alertType('该文档已固定位置,无法进行置顶操作', '', 'warning', false);
                    return;
                }
                var topFlag = $scope.data.selectedArray[0].DOCORDERPRI === '0' ? 2 : 0;
                modalDialog.confirmModal(
                    topFlag === 2 ? '置顶？' : '取消置顶？',
                    topFlag === 2 ? '确认要置顶该稿件？' : '确定要取消置顶该稿件？',
                    function () {
                        var params = {
                            serviceid: 'mlf_appoper',
                            methodname: 'setTopDocument',
                            ChannelId: $state.params.channelid,
                            DocumentId: $scope.data.selectedArray[0].METADATAID,
                            TargetDocumentId: $scope.data.items[0].DOCORDERPRI === '0' ? '0' : $scope.data.items[0].METADATAID,
                            TopFlag: topFlag,
                            Position: 1,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                if (angular.isArray(data.REPORTS)) {
                                    modalDialog.multiReportsAlert(data, function () {
                                        requestData();
                                    });
                                } else {
                                    modalDialog.alertType('', data.DETAIL, 'warning', 'confirm');
                                }
                            },
                            function () {
                                requestData();
                            }
                        );
                    }
                );
            };

            /**
             * [hide description] 隐藏已签发稿件
             * @return {[type]} [description]
             */
            $scope.hide = function () {
                var isSecondReview = checkSecondReview();
                if (isSecondReview === true) {
                    modalDialog.alertType('无法进行操作', '所选稿件中包含二次审核的稿件', 'error', false);
                    return;
                }
                $scope.status.isESSearch = false;
                var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                hide(chnlDocIds, metaDataId);
            };

            /**
             * [hide description] 隐藏已签发稿件函数
             * @param  {[type]} chnlDocIds [description]
             * @param  {[type]} metaDataId [description]
             * @return {[type]}            [description]
             */
            function hide(chnlDocIds, metaDataId) {
                modalDialog.confirmModal('隐藏', '是否确定修改显示状态？', function () {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'hidden',
                        ChannelId: $stateParams.channelid,
                        ChnlDocIds: chnlDocIds,
                        MetaDataIds: metaDataId,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            modalDialog.alertType('隐藏成功', '', 'success', false, function () {
                                requestData();
                            });
                        },
                        function () {
                            requestData();
                        }
                    );
                });
            }

            /**
             * [hide description] 已签发稿件取消隐藏
             * @return {[type]} [description]
             */
            $scope.cancelHidden = function () {
                $scope.status.isESSearch = false;
                var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                var metaDataId = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                cancelHidden(chnlDocIds, metaDataId);
            };

            /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
            $scope.atlasMode = function() {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
                $scope.status.hasphoto = !$scope.status.hasphoto;
                $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
            };

            /**
             * [hide description] 取消隐藏函数
             * @param  {[type]} chnlDocIds [description]
             * @param  {[type]} metaDataId [description]
             * @return {[type]}            [description]
             */
            function cancelHidden(chnlDocIds, metaDataId) {
                modalDialog.confirmModal('取消隐藏', '是否确定修改显示状态？', function () {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'cancelHidden',
                        ChannelId: $stateParams.channelid,
                        ChnlDocIds: chnlDocIds,
                        MetaDataIds: metaDataId,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('取消隐藏成功', '', 'success', false, function () {
                            requestData();
                        });
                    });
                });
            }

            /**
             * [fixed description] 稿件固定位置
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.fixed = function () {
                if ($scope.status.showFixPosition === false) {
                    modalDialog.confirmModal('取消固定位置', '是否确认取消固定位置', function() {
                        var params = {
                            serviceid: 'mlf_appoper',
                            methodname: 'fixedPositionOfMeta',
                            ChannelId: $stateParams.channelid,
                            ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                            IsFixedPos: false
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                            modalDialog.alertType('操作成功', '', 'success', false);
                            requestData();
                        });
                    });
                    return;
                }
                var isFocus = false;
                $scope.data.selectedArray.forEach((item) => {
                    if (item.FOCUSSHELVESSTATUS == '1' || item.FOCUSSHELVESSTATUS == '2') {
                        modalDialog.alertType('选择的稿件中存在已经上架为焦点图的稿件,无法固定位置', '', 'info', false);
                        isFocus = true;
                    }
                });

                if (!isFocus) {
                    if ($scope.data.selectedArray.length > 50) {
                        modalDialog.alertType('您已超出允许选择固定的稿件数量,只能固定50条', '', 'info', false);
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_appmetadata',
                        methodname: 'querySignedDocForFixed',
                        ChannelId: $stateParams.channelid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                        editingCenterService.fixPositionModel({
                            selectedArray: angular.copy($scope.data.selectedArray),
                            items: angular.copy(data.DATA),
                            firstPageItemsLenth: angular.copy($scope.data.firstPageItemsLenth),
                            // firstPageItems: angular.copy($scope.data.firstPageItems),
                        }, 'app').then((res) => {
                            requestData();
                        }, function () {
                            requestData();
                        });
                    });
                }
            };

            /**
             * [cancelFixed description] 取消固定位置
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.cancelFixed = function () {
                $scope.status.isESSearch = false;
                if ($scope.data.selectedArray.length > 1) {
                    modalDialog.alertType('取消定位无法多选', '', 'error', false);
                    return;
                }
                var chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                cancelPosition(chnlDocIds);
            };

            /**
             * [cancelPosition description] 取消固定位置函数
             * @param  {[type]} chnlDocIds [description]
             * @return {[type]}            [description]
             */
            function cancelPosition(chnlDocIds) {
                modalDialog.confirmModal('取消定位', '是否取消固定定位', function () {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'cancelFixedMetaDatas',
                        ChnlDocId: chnlDocIds,
                        ChannelId: $stateParams.channelid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        $scope.fixPos.splice($scope.fixPos.indexOf(Number($scope.data.selectedArray.GDORDER)));
                        requestData();
                    });
                });
            }

            /**
             * [exportDraft description] 导出稿件
             * @return {[type]} [description]
             */
            $scope.exportDraft = function () {
                $scope.status.isESSearch = false;
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
                if (temp.length <= 1) {
                    var params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        function (data) {
                            $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            $scope.data.selectedArray = [];
                        },
                        function (data) {
                            if (data.REPORTS[0].ISSUCCESS == 'true') {
                                $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                                $scope.data.selectedArray = [];
                            }
                        }
                    );
                } else {
                    modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [isOnlyMine description]只看我的
             * @return {Boolean} [description] null
             */
            $scope.isOnlyMine = function () {
                $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.onlyMine = !$scope.status.onlyMine;
                $scope.params.isOnlyMine = $scope.status.onlyMine;
                requestData();
            };

            /**
             * [queryByDropdown description] 筛选条件
             * @param  {[type]} key   [description]
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            $scope.queryDropDown = function (key, value) {
                $scope.params[key] = value;
                $scope.data.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                if (key === 'PushingStatusFilter') {
                    if (value === '0') {
                        $scope.params.PushingStatusFilter = 1;
                    } else if (value === '1') {
                        $scope.params.PushingStatusFilter = 0;
                    }
                }
                if (key === 'timeType') {
                    $scope.params.OperTimeStart = $scope.data.fromdate;
                    $scope.params.OperTimeEnd = $scope.data.untildate;
                    $scope.params[key] = null;
                }
                if (key === 'DocType' && value === '2') {
                    $scope.status.hasphotoflag = true;
                }
                requestData();
            };

            /**
             * [fullTextSearch description]全文检索
             *
             * @param   {[type]}  ev  [ev description]按下回车也能提交
             *
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.selectedClassify.value === 'DocID') {
                        $scope.status.isESSearch = false;
                        $scope.params.DocId = $scope.keywords;
                    } else {
                        $scope.status.isESSearch = true;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            };

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function () {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
                checkHasNoFixed();
            };

            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                getAllColumnsBtnRight(item);
                checkHasNoFixed();
            };

            /**
             * [ getFinalBtnRightdescription]点击第一次发请求
             * @param   {[type]}  item  [items description]
             * @return {[json]} [description] 参数对象
             */
            function getAllColumnsBtnRight(item) {
                if (!$scope.status.isAllColumns) {return;}
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.btnRights = editingCenterAppService.initQianFaBtnRight();
                    return ;
                }

                if (!$scope.data.requestedColumnsBtnRight[item.CHANNELID]) {
                    $scope.loadingPromise = editcenterRightsService.initAppListBtn('app.yiqianfa', item.CHANNELID).then(function (rights) {
                        $scope.data.requestedColumnsBtnRight[item.CHANNELID] = rights;
                        $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.data.requestedColumnsBtnRight);
                    });
                } else {
                    $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.data.requestedColumnsBtnRight);
                }
            }

            /**
             * [checkHasNoFixed description] 查看是否被固定
             * @return  {[type]}  [return description]
             */
            function checkHasNoFixed() {
                for (let i = 0; i < $scope.data.selectedArray.length;i++) {
                    if ($scope.data.selectedArray[i].GDORDER == '0' || !$scope.data.selectedArray[i].GDORDER) {
                        $scope.status.showFixPosition = true;
                        break;
                    } else {
                        $scope.status.showFixPosition = false;
                    }
                }
            }

            $scope.dropCallback = function (event, index, item, external, type, allowedType) {
                if (!$scope.status.btnRights['app.yiqianfa.gaojianpaixu']) {
                    modalDialog.alertType('登录用户没有权限对稿件进行排序', '', 'error', 'confrim');
                    return;
                }
                var trueIndex;
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'sortPositionMetaDatas',
                    ChannelId: $stateParams.channelid,
                    FromChnlDocId: item.CHNLDOCID,
                };
                if ($scope.moveIndex < index) {
                    trueIndex = index - 1;
                    params.Position = 0;
                } else {
                    trueIndex = index;
                    params.Position = 1;
                }
                params.ToChnlDocId = $scope.data.items[trueIndex].CHNLDOCID;
                if (item.GDORDER > 0 || $scope.data.items[trueIndex].GDORDER > 0) {
                    modalDialog.alertType('操作失败', '所操作的稿件存在已经固定位置的稿件,无法移动位置', 'warning', true);
                    return;
                }
                if (item.FOCUSSHELVESSTATUS == '1' || item.FOCUSSHELVESSTATUS == '2') {
                    modalDialog.alertType('操作失败', '该稿件已上架为焦点图,无法排序', 'warning', true);
                    return;
                }
                modalDialog.alertType(
                    '位置调整',
                    '确定调整位置么？',
                    'info',
                    true,
                    function () {
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                            requestData();
                        });
                    },
                    function () {
                        requestData();
                    }
                );
                return item;
            };
            // h5拖拽结束
            $scope.getIndex = function (index) {
                $scope.moveIndex = index;
            };

            /**
             * [showVersionTime description]展示流程版本与操作日志
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [selectPageNum description]每页显示的数据数量
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectPageNum = function () {
                $scope.data.copyCurrPage = 1;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description] 跳转到指定页面
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function () {
                if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.data.copyCurrPage;
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };

            /**
             * [cancelFixedPosition description]监听取消固定置顶位置
             *
             * @return  {[type]}  [return description]
             */
            function cancelFixedPosition() {
                messagePublishService.subscribe(
                    'refreshFixedPosition',
                    function () {
                        requestData();
                    },
                    $scope
                );
            }

            /**
             * [isLockEdit description]编辑前请求解锁
             *
             * @param   {[type]}  item  [item description]稿件对象
             *
             * @return  {[type]}        [return description]
             */
            $scope.isLockEdit = function (item) {
                $scope.status.isESSearch = false;
                editIsLock.isLock(item, 1).then(function (data) {
                    var editPath = $scope.data.editPath[item.DOCTYPEID];
                    var editParams = {
                        appchannelid: $stateParams.channelid,
                        appchnldocid: item.CHNLDOCID,
                        appmetadataid: item.METADATAID,
                        appsiteid: $stateParams.siteid,
                        appplatform: 2,
                    };
                    var editUrl = $state.href(editPath, editParams);
                    if (data.ISLOCK == 'false') {
                        $window.open(editUrl);
                    } else {
                        editIsLock.checkUnlockPermissions(item, data).then(function () {
                            $window.open(editUrl);
                        });
                    }
                });
            };

            /**
             * [appPreview description] app稿件预览
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.appPreview = function (item) {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID,CHNLDOCID', 'appPreview');
            };

            /**
             * [appMobilePreview description]客户端手机端模板预览
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.appMobilePreview = function (item) {
                editingCenterAppService.appPrevewPublish(item.CHNLDOCID).then(
                    function () { },
                    function () {
                        editIsLock.lockDraft(item.CHNLDOCID);
                    }
                );
            };

            /** 多元分发
             * [distribution description]
             * @return {[type]} [description]
             */
            $scope.distribution = function () {
                $scope.status.isESSearch = false;
                if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
                    modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                    return;
                }
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
                if (temp.length < 1) {
                    editingCenterService.distribution($scope.data.selectedArray, '1', $scope.data.selectedArray[0].DOCTYPEID, 'appYiQianFaDistribute', function () {
                        $scope.data.selectedArray = [];
                        requestData();
                    });
                } else {
                    modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、图集、视频', 'warning', 'confirm', function () { });
                }
            };

            /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
             * [examDistributionType description]
             * @param  {[type]} elm [description]
             * @return {[type]}     [description]
             */
            $scope.examDistributionType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2 && elm.DOCTYPEID != 7;
                }
            };

            /**
             * [tenantManuShare 租户间共享]
             * @return {[type]} [description]
             */
            $scope.tenantManuShare = function () {
                if (!hasShareFlag()) {
                    modalDialog.alertType('无法进行共享', '所选稿件中包含活动稿、专题稿、音频稿和话题稿', 'info', 'confirm', function () { });
                    return;
                }
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'pluralisticShare',
                    dataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                };
                editingCenterService.tenantShareManu(params).then(function (data) {
                    if (data == 'success') {
                        requestData();
                        $scope.data.selectedArray = [];
                    }
                });
            };

            /**
             * [hasShareFlag description]
             *
             * @return  {[type]}  [return description]
             */
            function hasShareFlag() {
                var flag = true;
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if (
                        $scope.data.selectedArray[i].DOCTYPEID == 3 ||
                        $scope.data.selectedArray[i].DOCTYPEID == 5 ||
                        $scope.data.selectedArray[i].DOCTYPEID == 6 ||
                        $scope.data.selectedArray[i].DOCTYPEID == 12 ||
                        $scope.data.selectedArray[i].DOCTYPEID == 13
                    ) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }

            /**
             * [multiSign description]多签
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.multiSign = function (item) {
                $scope.status.isESSearch = false;
                var selectedArray;
                if (!!item) {
                    selectedArray = [item];
                } else {
                    selectedArray = $scope.data.selectedArray;
                }
                editRepetitiveBtnService.multipleChannelSign(selectedArray, 6).then(() => {
                    requestData();
                }, () => {
                    requestData();
                });
            };

            /**
             * [preview description]稿件预览
             * @param   {[type]}  item    [item description] 选中的稿件对象
             * @param   {[type]}  isOpen  [isOpen description]isOpen 是否打开生成的地址，只有明确设置为false时，才不打开
             * @return  {[type]}          [return description]
             */
            $scope.preview = function (item, isOpen) {
                var deffer = $q.defer();
                $scope.status.isESSearch = false;
                var params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'getDocPubUrl',
                    CHNLDOCID: item.CHNLDOCID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data.replace(/"/g, ''));
                    if (isOpen !== false) {
                        $window.open(data.replace(/"/g, ''));
                    }
                });
                return deffer.promise;
            };

            /**
             * [generateQrcode description]生成二维码
             * @param   {[type]}  item  [item description] 稿件对象
             * @return  {[type]}        [return description]
             */
            $scope.generateQrcode = function (item) {
                $scope.preview(item, false).then(function (data) {
                    editingCenterService.generateQrcode(data);
                });
            };

            /**
             * [forwardNews description] app已签发稿件推送消息，一旦推送，不可撤销
             * @param   {[type]}  item  [item description] 需要推送的稿件对象
             * @return  {[type]}        [return description]
             */
            $scope.forwardNews = function (item) {
                editingCenterAppService.appPushNews(item).then((result) => {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'pushSignedDocMessage',
                        ChnlDocId: result.CHNLDOCID,
                        CurrChnlId: $scope.status.channelId,
                        title: result.editTitle,
                        abstract: result.editAbstract
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function () {
                        modalDialog.alertType('推送成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

        },
    ]);
